module.exports = __webpack_public_path__ + "img/D2-e.bd15b8f5.jpg";